import { Deal } from '../Models/Deal';
import DataGridRequest from './DataGridRequest';
export class DealsRequest extends DataGridRequest<Deal> {
    Url = '/deals/api';
}
